<template>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card style="box-shadow:none">
          <md-card-header class="md-card-header-icon md-card-header-blue" style="display:flex">
            <div class="card-icon" style="align-self: flex-start">
              <md-icon>assignment</md-icon>
            </div>
            <h2 class="title" style="font-weight: bold; align-self: center;margin-top:10px">Disabled Users</h2>
            <md-button class="md-warning md-dense" @click="onPressEnabledUsers" style="align-self:center;margin-top:10px;margin-left:auto;">
                <md-icon>visibility</md-icon>
                Enabled Users
              </md-button>
          </md-card-header>
          <md-card-content>
            
            <md-table
              :value="deletedUsers"
              :md-sort.sync="sortation.field"
              :md-sort-order.sync="sortation.order"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover mt-4"
            >
              <!-- <md-table-toolbar>
                <md-field>
                  <label>Per page</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                      {{ item }}
                    </md-option>
                  </md-select>
                </md-field>
              </md-table-toolbar> -->
  
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name" md-sort-by="name">{{
                  item.nombre
                }}</md-table-cell>
                <md-table-cell md-label="Email" md-sort-by="email">{{
                  item.email | truncate(20,'...')
                }}</md-table-cell>
                <md-table-cell md-label="Created At" md-sort-by="created_at">{{
                   item.created_at | formatDate 
                }}</md-table-cell>
                <md-table-cell md-label="Roles" md-sort-by="roles"><span class="rol-square">{{
                item.roles[0] &&   item.roles[0].name
                }}</span></md-table-cell>
                <md-table-cell md-label="Actions">
                  <md-button
                    class="md-icon-button md-raised md-round md-success"
                    @click="onPressEnable(item.id)"
                    style="margin: 0.2rem"
                  >
                    <md-icon>visibility</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
  
          </md-card-content>
  
          <md-card-actions md-alignment="space-between">
            <!-- <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div> -->
            <!-- <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            /> -->
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination";
  
  export default {
    components: {
      // pagination: Pagination,
    },
  
    data: () => ({
      deletedUsers:[],
      footerTable: ["Name", "Email", "Created At", "Actions"],
  
      query: null,
  
      sortation: {
        field: "created_at",
        order: "asc",
      },
  
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
      },
  
      total: 1,
    }),
  
    computed: {
      sort() {
        if (this.sortation.order === "desc") {
          return `-${this.sortation.field}`;
        }
  
        return this.sortation.field;
      },
  
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    created() {
      this.getDeletedUsers();
    },
  
    methods: {
  
      getDeletedUsers() {
        this.$store.watch(() => this.$store.getters["users/deletedList"], (list) => {
          this.deletedUsers = list
        })
        this.$store.dispatch("users/deleted",{deleted:true})
      },
  
      onPressEnabledUsers(){
        this.$router.push({ name: "List Users" });
      },
  
      async onPressEnable(userId){
        try {
          await this.$store.dispatch("users/enable", userId);
          await this.$store.dispatch(
            "alerts/success",
            "User successfully enabled."
          );
          this.$store.watch(() => this.$store.getters["users/deletedList"], (list) => {
          this.deletedUsers = list
        })
        this.$store.dispatch("users/deleted",{deleted:true})
        } catch (e) {
          await this.$store.dispatch(
            "alerts/error",
            "Oops, something went wrong!"
          );
        }
      },
  
      customSort() {
        return false;
      },
    },
  };
  </script>
  <style>
  #pro-feature {
    font-weight: bold;
  }
  </style>
  